var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clear-filters-wrapper"},[_c('a',{staticClass:"clear-filters-button",attrs:{"href":_vm.getUrlNoFilters}},[_c('span',[_vm._v(_vm._s(_vm.t('filters.clear.all')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }